function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { EVENT } from "../../utils/constants";
import { Icon, JSONViewer, Text, useTheme, View } from 'unitx-ui';
import useAnimation, { animated } from 'unitx-ui/hooks/useAnimation';
import { DataEditor } from "./DataEditor";
const WIDTH_PROPORTION = 30;
const AnimatedSurface = animated(View);

const DataBar = props => {
  const {
    editable = true,
    item,
    onEvent,
    opened = false
  } = props,
        rest = _objectWithoutProperties(props, ["editable", "item", "onEvent", "opened"]);

  const {
    props: animatedProps,
    ref: animationRef
  } = useAnimation({
    from: {
      right: `-${WIDTH_PROPORTION}%`
    },
    to: {
      right: '0%'
    },
    autoStart: false
  });
  const theme = useTheme(); // const initialized = React.useRef(false)

  React.useEffect(() => {
    var _animationRef$current, _animationRef$current2;

    (_animationRef$current = animationRef.current) === null || _animationRef$current === void 0 ? void 0 : (_animationRef$current2 = _animationRef$current.reverse) === null || _animationRef$current2 === void 0 ? void 0 : _animationRef$current2.call(_animationRef$current, {
      reversed: !opened
    });
  }, [animationRef, opened]);
  const createOnActionCallback = React.useCallback((type, extraData) => // @ts-ignore
  () => onEvent === null || onEvent === void 0 ? void 0 : onEvent({
    type,
    extraData
  }), [onEvent]); // React.useEffect(() => {
  //   animationRef?.current?.start()
  // }, [])

  return /*#__PURE__*/React.createElement(AnimatedSurface, {
    style: _objectSpread({
      position: 'absolute',
      width: `${WIDTH_PROPORTION}%`,
      height: '100%',
      top: 0,
      // @ts-ignore
      backgroundColor: theme.colors.surface
    }, animatedProps)
  }, item && /*#__PURE__*/React.createElement(Text, {
    category: "label"
  }, ` id: ${item === null || item === void 0 ? void 0 : item.id}`), editable && (item === null || item === void 0 ? void 0 : item.data) ? /*#__PURE__*/React.createElement(DataEditor, _extends({
    data: item.data,
    onEvent: onEvent
  }, rest)) : /*#__PURE__*/React.createElement(JSONViewer, {
    data: item === null || item === void 0 ? void 0 : item.data
  }), /*#__PURE__*/React.createElement(Icon, {
    style: {
      position: 'absolute',
      left: -24,
      top: 0
    },
    name: "information-outline",
    size: 24,
    circle: true,
    onPress: createOnActionCallback(EVENT.TOGGLE_DATA_BAR)
  }));
};

export default DataBar; // wrapComponent<DataBarProps>(DataBar, {})